import { connect } from 'react-redux';
import Group from './Group';
import {
  canEditGroupsInForecast,
  isForecastView,
  selectGroupForecast,
  selectGroupMatches,
} from '@selectors/matches';
import {
  selectViewAssertionsByMid,
  withViewAssertions,
} from '@selectors/bracketView';

import { isSnapshotView } from '@selectors/location';

export const mapStateToProps = (state, { group }) => {
  const matches =
    isSnapshotView(state) || isForecastView(state)
      ? selectGroupForecast(state)[group]
      : selectGroupMatches(state)[group];

  return {
    // Marcas de aciertos desde la capa vigente del server (consistente con el bracket).
    matches: withViewAssertions(matches, selectViewAssertionsByMid(state)),
    editable: !isSnapshotView(state) && canEditGroupsInForecast(state),
  };
};

export const mapDispatchToProps = dispatch => ({
  onChange: (mid, payload) =>
    dispatch({
      type: 'FORECAST_MATCHES_MATCH_SET',
      meta: { mid },
      payload
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(Group);
